<template>
  <div>
    <ul>
      <li v-for="item in items" @click="openItem(item)" v-bind:key="item.id">
        <div
          class="arrow_box"
          :class="{ 'arrow_box--open': item.isopen }"
        ></div>
        {{ item.title }}
        <transition v-on:enter="enter" v-on:leave="leave">
          <div v-show="item.isopen" class="item">
            {{ item.content }}
            <div
              class="video"
              v-bind:key="snippet.id"
              v-for="snippet in jsonData"
              data-key="{snippet.id}"
            >
              <div
                @click="showVideo(snippet.snippet.resourceId.videoId)"
                class="hover"
              >
                {{ snippet.snippet.title }}
              </div>
            </div>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import Velocity from "velocity-animate";
//import { bus } from "../main";
import store from "@/components/store";

const key = "AIzaSyAUHqj8bukFN8gTxiRUtQB846ABSYDs7Zo";
const URL = "https://www.googleapis.com/youtube/v3/playlistItems";

export default {
  data() {
    return {
      isHovering: false,
      jsonData: null,
      items: [
        {
          id: "PLIh_aKrRpW7Q-LptF9pKRC2loy-_qCbE0",
          title: "ElasticSearch and Kibana",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7SNdT5LZhEakJrQILfTpUOO",
          title: "Basic VueJs Series",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7QyDEbkPCr_Pomkr89Xw_E1",
          title: "Blazor - Security",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7SQXtwCwZfb56-OnZLb7rTM",
          title: "C# ASP.NET Core 3.1",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7T3BA9eSEF4ullWkIF9iNuS",
          title: "Identity Server 4 with ASP.NET Core 3.1",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7T7w6wrms0DpxsGD15VcUrV",
          title: "Data Structure (C# and Javascript)",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7Sxh7_P2N9sZNUOWvA34BvT",
          title: "Object-Oriented Programming in C#",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7TRA8snCbj2wkfY6nSO_Pm2",
          title: "Layered Architecture Design with C# Series",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7SH03ZCMndLnKYvPIah-hYE",
          title: "JQuery / Javascript",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7Q5FAsAqHwwRZ4zX4jATB3U",
          title:
            "C# ADO.NET Entity Data Model in Console (.NET Framework) - CRUD Series",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7QvmMa2Tq6Jbl4QTUZ_WiPF",
          title: "Android App with Java and Android Studio",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7TrH-FDQrEf8xpTwdb9cpO5",
          title: "To Do List with Javascript Series",
          content: "",
          isopen: false
        },
        {
          id: "PLIh_aKrRpW7QMaO9o7xxmasz0pvvvEoU-",
          title: "Sample Demo Program and Mockup App",
          content: "",
          isopen: false
        }
      ]
    };
  },
  methods: {
    loadVideos(playlistId) {
      const options = {
        params: {
          part: "snippet",
          key: key,
          maxResults: 30,
          playlistId: playlistId
        }
      };
      axios
        .get(URL, options)
        .then(response => (this.jsonData = response.data.items))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          // console.log(this.jsonData);
        });
    },
    showVideo(videoId) {
      // debugger;
      // console.log(videoId);
      //this.iframesrc = "https://www.youtube.com/embed/" + videoId;
      //bus.$emit("iframesrc", "https://www.youtube.com/embed/" + videoId);
      store.iframesrc = "https://www.youtube.com/embed/" + videoId;
    },
    openItem: function(item) {
      //console.log(item.id);
      this.loadVideos(item.id);
      item.isopen = !item.isopen;
    },

    setClass: function(item) {
      return item.isopen == true ? "open" : "close";
    },

    enter: function(el, done) {
      debugger;
      Velocity(
        el,
        "slideDown",
        { duration: 400, easing: "easeInBack" },
        { complete: done }
      );
    },

    leave: function(el, done) {
      debugger;
      Velocity(
        el,
        "slideUp",
        { duration: 400, easing: "easeInBack" },
        { complete: done }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hover:hover {
  color: red;
}
/* Velocity accordian animate - start */
/* https://codepen.io/enolic/pen/rrvyqK?editors=0110 */
@import "https://fonts.googleapis.com/css?family=Cantata+One|Noto+Sans:400,400i,700,700i&subset=latin-ext";

li {
  list-style: none;
  cursor: pointer;
  font: 22px/48px "Cantata One", serif;
}
li > div {
  font: 14px/22px "Noto Sans", serif;
  padding-bottom: 20px;
}

.item {
  overflow: hidden;
  padding: 5px;
  /* width: 100px; */
}

.arrow_box {
  width: 10px;
  height: 10px;
  transition: all 0.3s;
  padding-bottom: 0px;
  position: absolute;
  margin: 20px 0px 0px -15px;
}

.arrow_box:after,
.arrow_box:before {
  border: solid transparent;
  content: " ";
  position: absolute;
}

.arrow_box:after {
  border-width: 5px;
}
.arrow_box:before {
  border-left-color: #000;
  border-width: 5px;
}

.arrow_box--open {
  transform: rotateZ(90deg);
  transform-origin: 50% 50%;
}
/* Velocity accordian animate - end */

.video {
  padding: 10px;
}

div.right {
  background-color: antiquewhite;
}

.main {
  width: 98%;
  margin: 0 auto;
}

.hovering {
  cursor: pointer;
  background-color: #fff2ac;
  background-image: linear-gradient(to left, #ffe359 0%, #fff2ac 100%);
}
</style>
